<template>
  <div>
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.type"
        :multi-line="true"
        :timeout="5000" >
      {{ snackbar.message }}
    </v-snackbar>
    <loading-dialog v-model="showLoadingDialog"/>

    <v-dialog v-model="show" max-width="400px">
      <v-card class="pa-3">
        <v-card-title class="pa-0">
          <h2>Extended Warranty</h2>
          <v-spacer />
          <v-btn flat icon color="itoviGrayMid" @click="show=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text v-if="ccInfo" class="pt-0 pl-3 pr-3">
          <div class="text-md-center mt-3 mb-2">
            {{ getWarrantyMessage() }}
          </div>
          <div v-if="extendedWarranty" class="pb-4 text-sm-center">
            Your card ending in
            <b>{{ ccInfo.last_four }}</b>
            will be charged
            <b>${{ formatPrice(extendedWarranty.price) }}.</b>
            <span class="txt-button-blue txt-bold" @click="openCcDialog()">
            Update Card
          </span>
          </div>
          <div v-if="extendedWarranty" class="text-xs-center">
            <button  class="button-blue" @click="purchase()">Pay ${{ formatPrice(extendedWarranty.price) }} now</button>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  import store from '@/store';
  import subscribeToStore from "@/mixins/subscribeToStore";
  import LoadingDialog from "@/components/LoadingDialog";
  import { formatPrice } from "@/helpers/priceHelper";
  import api from "@/services/api_endpoints";

  export default {
    components: {
      LoadingDialog,
    },
    data() {
      return {
        addOns: store.state.addOns,
        planDetails: store.state.planDetails,
        ccInfo: store.state.ccInfo,
        showPurchaseWarrantyDialog: true,
        extendedWarranty: null,
        hasWarranty: false,
        showLoadingDialog: false,
        snackbar: {
          show: false,
          message: "An unknown error occurred",
          type: "error"
        },
      }
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
    },
    mixins: [subscribeToStore],
    mounted() {
      this.subscribeToStore(['addOns', 'ccInfo', 'planDetails']);
    },
    watch: {
      addOns: function (val) {
        this.getExtendedWarranty(val);
        this.hasExtendedWarranty(val);
      }
    },
    methods: {
      formatPrice,
      openCcDialog() {
        this.$store.commit('setShowUpdateCcDialog',true)
      },
      getExtendedWarranty(addOns) {
        if(!addOns) return;
        const extendedWarranty = addOns.available.filter((addOn) => addOn.name === "Extended Warranty")[0];
        if(extendedWarranty) this.extendedWarranty = extendedWarranty;
      },
      hasExtendedWarranty(addOns) {
        if(!addOns) return;
        this.hasWarranty = !!addOns.applied.filter((addOn) => addOn.name === "Extended Warranty" || addOn.name === "Insurance").length;
      },
      async purchase() {
        this.showLoadingDialog = true;
        let response = await api.submitAddOnPurchase([this.extendedWarranty]);
        this.showLoadingDialog = false;

        if (response.success) {
          this.extendedWarranty = null;
          await api.getPlanAddOns();
          this.show = false;
          this.$store.commit('setShowSuccessDialog', {active: true, message: `Congrats! You have successfully purchased an Extended Warranty for your iTOVI!`});
        } else {
          this.snackbar = {
            show: true,
            type: "error",
            message: response.errorMessage
          }
        }
      },
      getWarrantyMessage() {
        if (this.hasWarranty) return 'Congrats! Your Extended Warranty is effective.';
        if (this.extendedWarranty) return this.extendedWarranty.description;
        if (this.planDetails && this.planDetails.status === 'paused') return 'Your account is currently paused, activate your account to purchase an extended warranty!';
        return "Don't forget to buy an extended warranty after you purchase your iTOVi scanner.";
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>